import "./contact.css";
import React from "react";
import {useNavigate} from "react-router-dom";
import FooterLinks from "../../components/FooterLinks/footerLinks.jsx";

const FavoritesPage = () => {
  const navigate = useNavigate();

  const redirectToBack = () => {
    navigate(-1);
  };

  return (
    <section id="contact" className="section">
      <div className="section">
        <div className="contact__page_wrapper">
          <div className="contact__page">
            <h2 className="contact__page_title">Contact Us</h2>

            <div className="contact__logo_wrapper">
              <img
                className="contact__logo"
                src={require("./img/image.png")}
                alt="contact__logo"
              />
            </div>
            <div id="contact__text" className="contact__page_text">
              <p>
                The service provider is Vassabi Limited, Unit 1603, 16th floor,
                The L. Plaza 367 – 375 Queen’s Road Central Sheung Wan, Hong
                Kong
              </p>
              {/* <p>
                <strong>Phone:</strong> +359 24928370
              </p> */}
              <p>
                <strong>Email:</strong> support@vassabi.com
              </p>
            </div>

            <button className="contact__page_button" onClick={redirectToBack}>
              Back
            </button>
          </div>
        </div>
      </div>
      <FooterLinks/>
    </section>
  );
};

export default FavoritesPage;
